/**
 * Titel: FLOWBOX
 * Beskrivelse: bruges primært til visning af kontaktpersoner på medarbejdersider, samt til åbningstider for it-supporten
 * Status: ES5-syntax hele vejen igennem; bør omskrives til ES6/React
 */

AU.flowbox_legacy = {
  options: {
      config: {
          container: '.au_flowbox',
          tracking: '/virtual/flowbox/',
          render: 'ul',
          multipleDepartments: false
      },
      data: {
          mode: 'list',
          source: '.au_flowbox_list',
          headline: 'Overskrift',
          prepend: '',
          prependIndex: 0,
          byline: ''
      }
  },
  boxes: [],
  mergeOptions: function (box) {
      if (!box.hasOwnProperty('config')) {
          box.config = {};
      }

      for (var conf in this.options.config) {
          if (!box.config.hasOwnProperty(conf)) {
              box.config[conf] = this.options.config[conf];
          }
      }

      if (!box.hasOwnProperty('data')) {
          box.data = {};
      }

      for (var data in this.options.data) {
          if (!box.data.hasOwnProperty(data)) {
              box.data[data] = this.options.data[data];
          }
      }

  },
  init: function () {

      for (var i = 0; i < this.boxes.length; i++) {

          var box = this.boxes[i];
          this.mergeOptions(box);

          box.id = i;
          box.container = $(box.config.container);
          box.items = [];
          box.items.name = box.data.headline;
          box.items.children = [];
          box.items.parent = null;

          this.data.get(box);

      }
  },
  data: {
      get: function (box) {
          if (typeof box.container !== "undefined") {

              var parseList = function (items, source) {

                  $(source).each(function () {
                      $('> li > p', this).each(function () {
                          var obj = {
                              name: $(this).html(),
                              children: [],
                              parent: items
                          };

                          items.children.push(obj);
                          var children = $('> ul', $(this).parent());
                          if (children.length > 0) {
                              parseList(obj, children);
                          }
                      });
                  });
              };

              switch (box.data.mode) {
                  case 'list':
                      parseList(box.items, box.data.source);
                      this.render(box, box.items, 0);
                      break;
                  default:
                      break;
              }

          }
      },
      foundPeople: [],
      findSearchableData: function (text, render) {

          if (typeof AU.ipure !== "undefined" && text.indexOf(' ') === -1) {
              return '<div class="au_flowbox_wrap person loading" data-phone="' + text + '"></div>';

          } else {

              if (render === "ul") {
                  return '<li>' + text + '</li>';
              }

              if (render === "select") {
                  return '<div class="au_flowbox_wrap"><p>' + text + '</p></div>';
              }

              return text;

          }
      },
      render: function (box, items, index) {

          if (typeof box.container !== "undefined") {

              box.container.empty();

              var html, i;

              if (box.config.render === "ul") {

                  html = "<h2>" + (index <= box.data.prependIndex ? box.data.prepend : '') + items.name + "</h2><ul>";
                  html += box.data.byline;
                  for (i = 0; i < items.children.length; i++) {
                      if (items.children[i].children.length === 0) {
                          html += this.findSearchableData(items.children[i].name, box.config.render);
                      } else {
                          html += '<li><a class="next" href="#" data-index="' + index + '" data-id="' + i + '">' + items.children[i].name + '</a></li>';
                      }
                  }
                  html += '</ul>';

                  if (items.parent !== null) {
                      html += '<p><a class="prev" href="#" data-index="' + index + '">' + (AU.pageLang === "da" ? 'Tilbage' : 'Back') + '</a></p>';
                  }

                  box.container.html(html);



                  $('.next', box.container).click(function (e) {
                      e.preventDefault();

                      var index = parseInt($(this).data('index'));
                      var id = parseInt($(this).data('id'));

                      AU.flowbox_legacy.data.render(box, items.children[id], index + 1);

                  });

              }

              if (box.config.render === "select") {

                  html = '<h2>' + (index <= box.data.prependIndex ? box.data.prepend : '') + items.name + '</h2>';
                  html += box.data.byline;
                  var selectBegin = '<select class="next" data-index="' + index + '"><option value="-1">' + (AU.pageLang === "da" ? 'Vælg...' : 'Select...') + '</option>';
                  var selectEnd = '</select>';

                  var options = [];
                  var paragraphs = [];

                  for (i = 0; i < items.children.length; i++) {
                      if (items.children[i].children.length === 0) {
                          paragraphs.push(this.findSearchableData(items.children[i].name, box.config.render));
                      } else {
                          options.push('<option value="' + i + '">' + items.children[i].name + '</option>');
                      }
                  }

                  if (options.length > 0) {
                      html += selectBegin;
                      for (i = 0; i < options.length; i++) {
                          html += options[i];
                      }
                      html += selectEnd;
                  }

                  if (paragraphs.length > 0) {
                      for (i = 0; i < paragraphs.length; i++) {
                          html += paragraphs[i];
                      }
                  }

                  if (items.parent !== null) {
                      html += '<p><a class="prev" href="#" data-index="' + index + '">' + (AU.pageLang === "da" ? 'Tilbage' : 'Back') + '</a></p>';
                  }

                  box.container.html(html);



                  $('.next', box.container).change(function (e) {
                      e.preventDefault();

                      var index = parseInt($(this).data('index'));
                      var id = parseInt($(this).val());

                      if (id > -1) {
                          AU.flowbox_legacy.data.render(box, items.children[id], index + 1);
                      }

                  });

              }

              if (box.config.render === "autocomplete") {
                  html = "<h2>" + (index <= box.data.prependIndex ? box.data.prepend : '') + items.name + "</h2>";
                  html += box.data.byline;
                  html += '<input placeholder="' + (AU.pageLang === "da" ? 'Søg efter uddannelse' : 'Search for education') + '" data-flowbox-ac="' + box.id + '" type="text" />';
                  html += '<div class="au_flowbox_ac_results"></div>';
                  box.container.html(html);

                  var search = $('[data-flowbox-ac="' + box.id + '"]');
                  search.autocomplete({
                      source: function (request, response) {
                          var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), 'i');
                          response($.grep($.map(items.children, function (key) {
                              return {
                                  label: key.name,
                                  value: key.name,
                                  children: key.children,
                                  parent: key.parent
                              };
                          }), function (value) {
                              value = value.label || value.value || value;
                              return matcher.test(value) || matcher.test(AU.helpers.normalizeAccents(value));
                          }));
                      },
                      minLength: 1,
                      autoFocus: true,
                      delay: 0,
                      select: function (e, ui) {

                          $('.au_flowbox_ac_results', box.container).empty().show();

                          var html = '<h3>' + ui.item.label + '</h3>';
                          for (var i = 0; i < ui.item.children.length; i++) {
                              html += '<p>' + ui.item.children[i].name + '</p>';
                          }

                          $('.au_flowbox_ac_results', box.container).append(html);
                      }
                  }).data('ui-autocomplete')._renderItem = function (ul, item) {
                      return $('<li />').data('ui-autocomplete-item', item).append('<a class="ui-corner-all" href="' + item.url + '">' + item.label + '</a>').appendTo(ul);
                  };

              }

              var peopleBoxes = $('.au_flowbox_wrap.person');
              peopleBoxes.each(function () {
                  var me = $(this);
                  var phone = me.data('phone');

                  var foundMarkup = "";
                  var fp = AU.flowbox_legacy.data.foundPeople;
                  for (var i = 0; i < fp.length; i++) {
                      if (parseInt(fp[i].id) === phone) {
                          foundMarkup = fp[i].markup;
                          break;
                      }
                  }

                  if (foundMarkup === "") {

                      AU.helpers.getXML(AU.ipure.source.searchCrossSite + phone, function (data) {
                          var people = AU.ipure.getPeople(data);
                          if (people.length === 1) {
                              AU.helpers.getXML(AU.ipure.source.searchDetailsCrossSite + people[0].url, function (data) {
                                  AU.ipure.getPersonDetails(data, function (personHTML, buildingNumber, email, officePhone, address, auid, centerMap) {
                                      me.html(personHTML);
                                      me.removeClass('loading');
                                      var officePhoneSplit = officePhone.split(' ');

                                      AU.flowbox_legacy.data.foundPeople.push({
                                          id: officePhoneSplit.length > 1 ? officePhoneSplit[1] : officePhone,
                                          markup: personHTML
                                      });
                                  }, box.config.multipleDepartments);

                              });
                          } else {
                              var pMarkup = '<p><a href="mailto:' + phone + '">' + phone + '</a></p>';
                              me.html(pMarkup);
                              me.removeClass('loading');

                              AU.flowbox_legacy.data.foundPeople.push({
                                  id: phone,
                                  markup: pMarkup
                              });
                          }
                      });

                  } else {
                      me.html(foundMarkup);
                      me.removeClass('loading');
                  }
              });

              $('.prev', box.container).click(function (e) {
                  e.preventDefault();

                  var index = parseInt($(this).data('index'));

                  AU.flowbox_legacy.data.render(box, items.parent, index - 1);

              });
          }

      }
  }
};